<template>
    <div>
        <div style="width: 90%; margin: auto; text-align: left">
          <p>小薪迹隐私政策</p>
          <p>生效日期：2025年3月26日</p>
          <p>欢迎使用小薪迹（以下简称“我们”或“小薪迹”）。小薪迹是一款帮助用户记录工时、工资、收入和支出的工具。我们非常重视您的隐私和数据安全，致力于保护您的个人信息。本隐私政策将详细说明我们如何收集、使用、存储和保护您的信息，以及您对这些信息的权利和选择。</p>
          <p>在使用小薪迹之前，请您仔细阅读并理解本隐私政策。如果您不同意本政策的内容，请勿使用我们的服务。一旦您开始使用小薪迹，即表示您已阅读、理解并同意本隐私政策的条款。</p>
          <p>1. 我们收集的信息</p>
          <p>为了提供更好的服务，我们可能会收集以下信息：</p>
          <p>1.1 您提供的信息</p>
          <p>账户信息：当您注册小薪迹账户时，我们可能会收集您的用户名、电子邮件地址、密码等信息。</p>
          <p>工时和财务数据：您在使用小薪迹记录工时、工资、收入和支出时输入的相关信息，例如工作时长、工资金额、收入来源、支出明细等。</p>
          <p>用户设置：您在应用中设置的偏好信息，例如货币单位、提醒设置等。</p>
          <p>1.2 自动收集的信息</p>
          <p>设备信息：我们可能会收集您的设备信息，包括设备型号、操作系统版本、唯一设备标识符（UDID）、IP 地址等。</p>
          <p>使用数据：我们可能会收集您使用小薪迹时的操作数据，例如访问时间、页面浏览记录、功能使用频率等。</p>
          <p>位置信息：如果您启用位置服务，我们可能会收集您的位置信息（仅在您授权的情况下），以便提供与位置相关的功能（如记录工作地点的工时）。</p>
          <p>1.3 通过第三方收集的信息</p>
          <p>第三方登录：如果您通过第三方账户（如微信、Apple ID）登录小薪迹，我们可能会从第三方获取您的基本信息（如昵称、头像），但仅限于您授权的范围。</p>
          <p>分析工具：我们可能会使用第三方分析工具（如 Firebase Analytics）来了解用户行为，这些工具可能会收集匿名化的使用数据。</p>
          <p>2. 我们如何使用您的信息</p>
          <p>我们收集的信息将用于以下目的：</p>
          <p>提供核心功能：记录和展示您的工时、工资、收入和支出数据，帮助您管理个人财务。</p>
          <p>个性化服务：根据您的使用习惯和偏好，提供个性化的提醒、统计图表和建议。</p>
          <p>改进产品：分析用户行为和反馈，优化小薪迹的功能和性能。</p>
          <p>用户支持：响应您的咨询或问题，提供技术支持。</p>
          <p>安全保障：检测和防止欺诈、滥用或其他非法活动，保护您的账户安全。</p>
          <p>法律合规：遵守适用的法律法规或响应法律程序。</p>
          <p>3. 我们如何保护您的隐私和数据安全</p>
          <p>我们非常重视您的隐私和数据安全，采取了以下措施来保护您的信息：</p>
          <p>3.1 数据加密</p>
          <p>我们在传输过程中使用 HTTPS 和 SSL/TLS 协议，确保您的数据在网络传输中是加密的。</p>
          <p>敏感数据（如密码）在存储时会进行加密处理，防止未经授权的访问。</p>
          <p>3.2 访问控制</p>
          <p>只有经过授权的员工才能访问您的个人信息，且仅限于履行其职责所需的范围。</p>
          <p>我们对内部系统设置了严格的权限管理，防止数据泄露。</p>
          <p>3.3 数据存储</p>
          <p>您的个人信息存储在安全的云服务器上，服务器位于符合数据保护法规的地区（如中国大陆或欧盟）。</p>
          <p>我们不会将您的工时、工资、收入和支出数据用于任何与小薪迹服务无关的目的。</p>
          <p>3.4 数据最小化</p>
          <p>我们仅收集提供服务所必需的信息，不会过度收集您的个人数据。</p>
          <p>您可以选择不提供某些信息，但这可能会影响部分功能的正常使用。</p>
          <p>3.5 匿名化处理</p>
          <p>在分析用户行为或生成统计数据时，我们会对数据进行匿名化处理，确保无法直接识别您的身份。</p>
          <p>3.6 安全事件响应</p>
          <p>如果发生数据泄露或其他安全事件，我们将立即采取措施减少影响，并按照法律法规要求通知您。</p>
          <p>4. 我们如何共享您的信息</p>
          <p>我们不会出售、交易或以任何形式向第三方出售您的个人信息。以下情况下，我们可能会共享您的信息：</p>
          <p>服务提供商：我们可能会与第三方服务提供商合作（如云存储提供商、数据分析服务），但仅限于提供小薪迹服务所需的范围。这些服务提供商必须遵守严格的保密协议。</p>
          <p>法律要求：如果法律、法院命令或政府机构要求，我们可能会依法披露您的信息。</p>
          <p>用户同意：在获得您的明确同意后，我们可能会与第三方共享您的信息。</p>
          <p>5. 您的权利和选择</p>
          <p>您对自己的个人信息拥有以下权利：</p>
          <p>访问和更正：您可以随时访问和修改您在小薪迹中输入的工时、工资、收入和支出数据。</p>
          <p>删除数据：您可以删除您的账户和相关数据。删除后，我们将停止处理您的信息，但可能需要保留部分数据以遵守法律义务。</p>
          <p>撤回同意：对于需要您授权的功能（如位置信息），您可以随时在设备设置中撤回授权。</p>
          <p>数据导出：您可以请求导出您的数据，我们将以结构化的格式提供。</p>
          <p>联系我们：如果您对隐私政策有任何疑问，或需要行使上述权利，请通过以下方式联系我们：</p>
          <p>电子邮件：support@xiaohuaxin.com</p>
          <p>客服电话：+86 123-456-7890</p>
          <p>6. 数据存储和跨境传输</p>
          <p>存储期限：我们仅在提供服务所需的期限内存储您的信息。如果您删除账户，我们将在合理的时间内（通常不超过 30 天）删除您的个人信息，除非法律要求保留。</p>
          <p>跨境传输：如果您所在地区的数据保护法规（如 GDPR）要求，我们会确保数据跨境传输符合相关法律要求。例如，您的信息可能会传输到位于中国大陆的服务器，我们将采取适当的保护措施。</p>
          <p>7. 第三方链接和服务</p>
          <p>小薪迹可能包含第三方链接（如支付服务）。这些第三方服务有其独立的隐私政策，我们不对其行为负责。建议您在使用第三方服务前仔细阅读其隐私政策。</p>
          <p>8. 儿童隐私</p>
          <p>小薪迹不面向 13 岁以下的儿童提供服务。如果我们发现未经监护人同意收集了儿童的个人信息，我们将立即删除相关数据。</p>
          <p>9. 隐私政策的更新</p>
          <p>我们可能会不时更新本隐私政策，以反映法律要求或服务变化。更新后，我们会在小薪迹应用内通知您，或通过电子邮件告知您。继续使用小薪迹即表示您同意更新后的隐私政策。</p>
          <p>10. 联系我们</p>
          <p>如果您对本隐私政策有任何疑问、建议或投诉，请通过以下方式联系我们：</p>
          <p>电子邮件：xiaohuaxin@jiaodu.fun</p>
          <p> 邮寄地址：山西省大同市平城区鹿苑街道站东大街叠翠园小区11号楼</p>
          <p>小薪迹团队</p>
          <p>2025年3月26日</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "yinsi",
};
</script>

<style scoped></style>
